import React from "react";

const TermsConditions = () => {
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "auto",
        padding: "40px",
        lineHeight: "1.7",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
        Terms and Conditions
      </h1>

      <h3>1. Introduction</h3>
      <p>
        Welcome to Cleanup Car Service Pvt Ltd. Car Wash Services. By accessing
        our website or mobile application and using our services, you agree to
        comply with and be bound by these Terms and Conditions. If you do not
        agree, please do not use our services.
      </p>
      <p>
        These terms apply to all users including customers who register and book
        car wash services.
      </p>

      <hr />

      <h3>2. Customer Responsibilities</h3>

      <p>
        <b>1. Vehicle Belongings</b>
      </p>
      <p>
        The vehicle owner will be fully responsible for any belongings or
        valuables left inside the vehicle before cleaning.
      </p>

      <p>
        <b>2. Water Requirement</b>
      </p>
      <p>
        A minimum of six to seven buckets of water may be required during the
        car wash process.
      </p>

      <p>
        <b>3. Electricity and Water Availability</b>
      </p>
      <p>
        The cleaner who visits your location will require access to water and
        electricity to perform the car cleaning service.
      </p>

      <p>
        <b>4. Cleaning Space</b>
      </p>
      <p>
        The vehicle owner must provide a suitable and safe space for the cleaner
        to perform the car cleaning service.
      </p>

      <p>
        <b>5. Society or Local Restrictions</b>
      </p>
      <p>
        If any issue arises with housing society management, neighbors, or any
        other person during the cleaning process, the responsibility will lie
        with the vehicle owner.
      </p>

      <p>
        <b>6. Post-Service Issue Reporting</b>
      </p>
      <p>
        If any issue or concern is noticed after the car cleaning service, it
        must be reported within two (2) hours of service completion. Any
        complaint reported after two hours may not be considered valid.
      </p>

      <hr />

      <h3>3. Services Provided</h3>
      <p>We provide the following services:</p>

      <ul>
        <li>One-time car wash services</li>
        <li>Subscription-based car wash plans (e.g., monthly plans)</li>
        <li>
          Vehicle cleaning at customer location or service station (depending on
          service availability)
        </li>
      </ul>

      <p>Service types may include:</p>

      <ul>
        <li>Exterior wash</li>
        <li>Interior cleaning</li>
        <li>Full car detailing</li>
        <li>Waterless wash</li>
        <li>Foam wash</li>
        <li>Other premium services</li>
      </ul>

      <p>Service availability may vary depending on location.</p>

      <hr />

      <h3>4. User Registration</h3>
      <ul>
        <li>Register with valid personal information</li>
        <li>Provide accurate vehicle details</li>
        <li>Maintain confidentiality of their account credentials</li>
      </ul>

      <p>
        Users are responsible for all activities under their account. We reserve
        the right to suspend or terminate accounts if false information or
        misuse is detected.
      </p>

      <hr />

      <h3>5. Booking Services</h3>
      <p>
        <b>One-Time Service</b>
      </p>
      <p>A single car wash service scheduled at a selected time.</p>

      <p>
        <b>Subscription Plans</b>
      </p>
      <ul>
        <li>Monthly 4 washes</li>
        <li>Monthly 2 washes</li>
        <li>Weekly wash plans</li>
      </ul>

      <p>
        Subscription plans are valid only within the specified period. Unused
        services may expire depending on the plan.
      </p>

      <hr />

      <h3>6. Pricing and Payments</h3>
      <ul>
        <li>Online payment gateway</li>
        <li>UPI / Wallet</li>
        <li>Credit/Debit card</li>
        <li>Other supported payment methods</li>
      </ul>

      <p>Prices may change without prior notice.</p>

      <hr />

      <h3>7. Cancellation and Rescheduling</h3>
      <ul>
        <li>Cancellation must be made before the scheduled time</li>
        <li>Late cancellations may not be eligible for refund</li>
        <li>Subscription services may have limited rescheduling</li>
      </ul>

      <hr />

      <h3>8. Service Conditions</h3>
      <ul>
        <li>Vehicle is accessible at the scheduled time</li>
        <li>Proper parking location is available</li>
        <li>Valuables are removed from the vehicle</li>
      </ul>

      <p>We are not responsible for lost items left inside vehicles.</p>

      <hr />

      <h3>9. Service Delays</h3>
      <p>
        Delays may occur due to weather conditions, traffic, technical issues,
        or staff availability. In such cases we will attempt to reschedule the
        service.
      </p>

      <hr />

      <h3>10. Limitation of Liability</h3>
      <ul>
        <li>Pre-existing vehicle damage</li>
        <li>Mechanical issues</li>
        <li>Electrical faults in vehicles</li>
        <li>Personal items left inside the car</li>
      </ul>

      <hr />

      <h3>11. Termination</h3>
      <p>
        We reserve the right to suspend or terminate service if users violate
        terms, misuse services, or engage in abusive behavior with staff.
      </p>

      <hr />

      <h3>12. Changes to Terms</h3>
      <p>
        We may update these Terms and Conditions at any time. Continued use of
        services means you accept the updated terms.
      </p>

      <hr />

      <h3>13. Contact Information</h3>
      <p>
        <b>Company Name:</b> Cleanup Car Service Pvt Ltd
      </p>
      <p>
        <b>Email:</b> manoj.cleanup@gmail.com
      </p>
      <p>
        <b>Phone:</b> +91 9426235075
      </p>
      <p>
        <b>Address:</b> BLOCK-M403, SAMRUDHHGREENS, OPP. MADHAV SCHOOL, Vastral,
        Daskroi, Ahmedabad - 382418, Gujarat
      </p>
    </div>
  );
};

export default TermsConditions;
